<app-header></app-header>
<section class="hero-wrap hero-wrap-2" style="background-image: url('../../assets/banner.jpg');">
  <div class="overlay"></div>
  <div class="container">
    <div class="row no-gutters slider-text align-items-center justify-content-center">
      <div class="col-md-9 ftco-animate text-center">
        <h1 class="mb-2 bread">Business Development Advisory</h1>
      </div>
    </div>
  </div>
</section>



<section class="ftco-section">
  <div class="container">
    <div class="row d-flex">
      <div class="col-md-12 order-md-last wrap-about align-items-stretch">
        <div class="wrap-about-border ftco-animate">
          <img src="../../assets/business_dev.jpg" class="img"/>
          <div class="text">
            <h3>Business Development Advisory</h3>
            <p>We look at business development as an integrated, cohesive effort that enhances business value, we help our clients to increase revenues, explore and set up new business line and opportunities for investments and attained sustainability by making necessary changes in business models, strategy and operations.</p>
            <p>We at <span style="color: #ff8416; font-weight: 700">MWC LLC</span>, help businesses to define their strategic direction, improve their market positioning and revenue generation.</p>
            <p><fa-icon [icon]="faCheckCircle" style="font-size:18px; color: #ff8416"></fa-icon> We advise startups as well as already-established small to medium and large-scale companies on how to raise capital investment as well as on market expansion and development.</p>
            <p><fa-icon [icon]="faCheckCircle" style="font-size:18px; color: #ff8416"></fa-icon> Through our  business development advisory , we guide businesses to make better decisions by using our extensive knowledge of local and regional markets and networking in identifying growth opportunities and building a competitive strategy based on our deep understanding of customers and the overall marketplace.</p>

            <br>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>

